const EventCard = ({ event, user, onDelete, onEdit }) => {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const eventDate = formatDate(event.date);
    const isMultiDay = event.endDate && new Date(event.endDate).getTime() !== new Date(event.date).getTime();
    const endDate = isMultiDay ? formatDate(event.endDate) : null;

    return (
        <div className="product-card event-card">
            {/* Edit/Delete Buttons - Only visible to logged-in users */}
            {user && (
                <div className="card-actions">
                    <button
                        className="action-btn edit-btn"
                        onClick={() => onEdit(event.id)}
                        title="Edit"
                    >
                        ✏️
                    </button>
                    <button
                        className="action-btn delete-btn"
                        onClick={() => onDelete(event.id)}
                        title="Delete"
                    >
                        🗑️
                    </button>
                </div>
            )}

            <div className="product-image">
                <img src={event.imageUrl} alt={event.title} />
            </div>
            <div className="product-info">
                <h3 className="product-name">{event.title}</h3>

                {/* Date Display */}
                {isMultiDay ? (
                    <div className="event-date-multi">
                        <div className="multi-day-badge">📅 Multi-day Event</div>
                        <div className="date-range">{eventDate} - {endDate}</div>
                    </div>
                ) : (
                    <p className="event-date">{eventDate}</p>
                )}

                <p className="product-description">{event.description}</p>
                <div className="product-footer">
                    <span className="product-price">KSh {event.cost.toFixed(2)}</span>
                    <a
                        href={event.eventUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-join-event"
                    >
                        Join Event
                    </a>
                </div>
            </div>
        </div>
    );
};

export default EventCard;
